

import React, { useEffect, useState } from "react";
import axios from "axios";
import ScrollToTop from "../ScrollToTop";
import { MagnifyingGlass } from "react-loader-spinner";

axios.defaults.baseURL = "https://api.freshcart4u.com";

const StoreList = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);

  /* =====================
     GET USER LOCATION
  ====================== */
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserLocation({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      () => {
        alert("Location permission required to order");
      }
    );
  }, []);

  /* =====================
     LOAD STORES
  ====================== */
  useEffect(() => {
    const loadStores = async () => {
      const res = await axios.get("/api/stores");
      setStores(res.data || []);
      setLoading(false);
    };
    loadStores();
  }, []);

  /* =====================
     DISTANCE (KM)
  ====================== */
  const getDistanceKm = (lat1, lon1, lat2, lon2) => {
    const toRad = (v) => (v * Math.PI) / 180;
    const R = 6371;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  if (loading || !userLocation) {
    return (
      <div className="loader-container">
        <MagnifyingGlass height="100" width="100" color="#0aad0a" />
      </div>
    );
  }

  return (
    <div>
      <ScrollToTop />

      <section className="container mt-5">
        <h2 className="mb-4">Stores Near You</h2>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {stores.map((store) => {
            const distance = getDistanceKm(
              userLocation.lat,
              userLocation.lng,
              store.latitude,
              store.longitude
            );

            const canOrder = distance <= store.serviceRadiusKm;

            return (
              <div className="col" key={store._id}>
                <div className="card p-4 h-100">
                  <img
                    src={store.logo}
                    alt={store.name}
                    style={{ width: 80 }}
                  />

                  <h5 className="mt-3">{store.name}</h5>

                  <p className="text-muted">
                    Service Radius: {store.serviceRadiusKm} km
                  </p>

                  <span className="badge bg-light text-dark mb-2">
                    {distance.toFixed(2)} km away
                  </span>

                  {canOrder ? (
                    <button className="btn btn-success w-100">
                      Order Now
                    </button>
                  ) : (
                    <button className="btn btn-secondary w-100" disabled>
                      Coming Soon in your area
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default StoreList;
